export const SERVICE_REQUESTS_TAB = 'service-requests';
export const PROPERTIES_TAB = 'properties';
export const PROPERTY_CERTIFICATES_TAB = 'property-certificates';
export const REGISTRATIONS_TAB = 'registrations';
export const CONSULTATIONS_TAB = 'consultations';

export const ALL_TIME = 'all-time';
export const LAST_30_DAYS = 'last-30-days';
export const DEFAULT_SHOW_REQUEST = '5';
